/* Apparition au défilement de la page d'accueil « deux portes ».
   Auto-protégé : ne s'initialise qu'une fois même si plusieurs sections l'appellent. */
(function(){
  if (window.__ghHomeInit) return; window.__ghHomeInit = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('gh-js');
  var voir = function(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, {threshold:.12});
    document.querySelectorAll('.gh-scope .reveal').forEach(function(el){ io.observe(el); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', voir);
  else voir();
  // l'éditeur de thème recharge les sections sans recharger la page
  document.addEventListener('shopify:section:load', voir);
})();
